export default __webpack_public_path__ + "static/media/update_applicant.dddb7bc9.png";